import React, { useEffect, useState } from 'react';
import './LoadingScreen.css';
import heroImg from '../images/logoRM.webp';

const LoadingScreen = () => {
  const [progress, setProgress] = useState(12);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((current) => {
        if (current >= 92) {
          clearInterval(interval);
          return current;
        }

        return current + 4;
      });
    }, 70);

    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <div className="loading-screen">
      <div className="loading-screen__glow loading-screen__glow--left" />
      <div className="loading-screen__glow loading-screen__glow--right" />

      <div className="loading-card">
        <div className="loading-card__topline" />
        <div className="loading-logo-shell">
          <img src={heroImg} alt="Amonthanat Massage logo" className="loading-logo" />
        </div>

        <p className="loading-eyebrow">Amonthanat Massage</p>
        <h1 className="loading-title">Preparing your visit</h1>
        <p className="loading-subtitle">
          Traditional Thai massage in Kathu, Phuket
        </p>

        <div className="loading-progress" aria-hidden="true">
          <div
            className="loading-progress__bar"
            style={{ width: `${progress}%` }}
          />
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;
